import TestVue from "@/views/TestView.vue";

const test = [
    {
        path: '/test',
        name: 'test',
        component: TestVue
    }
]

export default test;